import { render, staticRenderFns } from "./DashboardChicksBorn.vue?vue&type=template&id=2d595204&scoped=true"
import script from "./DashboardChicksBorn.vue?vue&type=script&lang=js"
export * from "./DashboardChicksBorn.vue?vue&type=script&lang=js"
import style0 from "./DashboardChicksBorn.vue?vue&type=style&index=0&id=2d595204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d595204",
  null
  
)

export default component.exports